import { RoleFormType } from 'components/roles/RoleForm';

export const updateRoleInitialValues: Partial<RoleFormType> = {};
